module fdm.flightSegment {

    angular.module('fdm.flightSegment')
        .config(['$stateProvider', '$locationProvider',
            ($stateProvider: ng.ui.IStateProvider,
                $locationProvider: ng.ILocationProvider) => {

                dg.uiRouter.StateProviderBuilderService.configure($stateProvider)
                    .dashboardState('ecmData', 'ecm-data',  
                        '{parentId}/flight-segment/ecm-data', {
                        options: () => <dg.actions.IQueryInvokerOptions>{
                            compositeDisplayers: <dg.actions.ICompositeDisplayerOptions>[
                                <dg.lists.IChartOptions>dg.lists.ChartService.getChartOptions({
                                    templateUrl: '/app/src/flight-segment/ecm-data.html'
                                }),
                            ],
                            hideActions: true,
                            exportOptions: <dg.navigation.IExportsListOptions>{
                                title: 'Download',
                                // Custom toolbar: ecm-diagnostics-export adds Export diagnostics (ZIP) and Cruise Performance (octet-stream).
                                excludeMediaTypes: ['application/zip', 'application/octet-stream']
                            },

                            //childDisplayers: {
                            //    KPIS: <dg.actions.ICompositeDisplayerOptions>{
                            //        templateUrl: '/digmo/src/actions/kpi/kpi-view.html',
                            //        displayValue: 'Kpi',
                            //        type: 'kpi'
                            //    }
                            //}
                        }
                    })
            }]);

}